<template>
  <v-container fluid class="pa-0" v-if="tabList.length > 0">
    <v-row align="center" justify="space-between" class="mb-4">
      <v-col cols="12">
        <div
          class=""
          :class="
            $vuetify.display.smAndDown ? '' : 'd-flex justify-space-between'
          "
        >
          <div>
            <div style="font-size: 30px; font-weight: 800">
              My Attendances & DTR
            </div>
            <div class="text-subtitle-2 mt-1">
              <span class="text-grey"
                >Track your internship hours and attendance records</span
              >
            </div>
          </div>
          <v-card
            flat
            rounded="xl"
            class="hours-card pa-4 d-flex align-center"
            style="min-width: 320px"
          >
            <div class="pa-2 flex-grow-1">
              <div
                class="text-caption text-grey font-weight-bold text-uppercase"
              >
                Rendered Hours
              </div>
              <div class="mt-1" style="color: #00a63e">
                <span class="font-weight-bold" style="font-size: 22px">{{
                  t_ojt_hrs ? t_ojt_hrs.toFixed(2) : "0.00"
                }}</span>
                <span class="text-caption text-grey ml-1"
                  >/ {{ ojt_hrs_to_complete ?? "—" }} hrs</span
                >
              </div>
            </div>
            <div
              style="border-left: 1px solid #e5e7eb; min-width: 140px"
              class="pa-4"
            >
              <div class="d-flex justify-space-between mb-1">
                <div class="text-caption text-grey">Progress</div>
                <div
                  class="text-caption font-weight-bold"
                  style="color: #00a63e"
                >
                  {{ getProgressPercentage.prct }}
                </div>
              </div>
              <v-progress-linear
                color="#00a63e"
                class="rounded-lg"
                height="8"
                :model-value="getProgressPercentage.val"
                bg-color="#e5e7eb"
              />
            </div>
          </v-card>
        </div>
      </v-col>
      <v-col cols="12">
        <v-btn
          class="white--text"
          color="#00A63E"
          prepend-icon="mdi-qrcode-scan"
          rounded="lg"
          @click="showQRScanner()"
        >
          Scan QR Code
        </v-btn>
      </v-col>
      <v-col cols="12" md="6" class="flex-items mt-2">
        <v-tabs v-model="activeTab" color="#00A63E" align-tabs="left">
          <v-tab
            v-for="tab in tabList"
            :value="tab.name"
            :key="tab.id"
            @click="changeTab(tab)"
            >{{ tab.name }}</v-tab
          >
        </v-tabs>
      </v-col>

      <!-- <v-col cols="12" md="6" class="d-flex justify-end align-center gap-3">
        <v-btn
          class="white--text"
          color="#00A63E"
          @click="addnew"
          prepend-icon="mdi-plus"
          rounded
        >
          Add Partner
        </v-btn>
      </v-col>-->
    </v-row>

    <v-col cols="12" v-if="tab == 1">
      <div class="d-flex justify-space-between" v-if="tab == 1 && !expandTab1">
        <div class="text-h6 font-weight-bold">Daily Time Record</div>

        <v-btn
          @click="genDtr"
          class="white--text"
          color="#00A63E"
          rounded="lg"
          prepend-icon="mdi-file-chart-outline"
        >
          Generate DTR
        </v-btn>
      </div>

      <div class="mt-4">
        <v-row v-if="tab == 1 && !expandTab1">
          <v-col cols="12">
            <v-card flat class="rounded-xl table-card">
              <v-data-table
                :headers="headers"
                :items="table_data"
                :search="search"
                :loading="loading"
                hover
                class="rounded-xl"
              >
                <template v-slot:[`item.organization_name`]="{ item }">
                  <span>{{ item.organization_name || "—" }}</span>
                </template>
                <template v-slot:[`item.date`]="{ item }">
                  <span v-if="item.date">{{ formatDate(item.date) }}</span>
                  <span v-else class="text-grey">—</span>
                </template>
                <template v-slot:[`item.time`]="{ item }">
                  <span v-if="item.time">{{ formatTime(item.time) }}</span>
                  <span v-else class="text-grey">—</span>
                </template>
                <template v-slot:[`item.type`]="{ item }">
                  <v-chip size="x-small" variant="tonal" color="teal">{{
                    formatType(item.type)
                  }}</v-chip>
                </template>

                <template #no-data>
                  <div class="text-center py-10">
                    <v-icon size="44" color="grey-lighten-1"
                      >mdi-calendar-clock-outline</v-icon
                    >
                    <div class="text-body-2 text-grey mt-2">
                      No attendance records yet.
                    </div>
                    <div class="text-caption text-grey-lighten-1">
                      Scan a QR code to log your attendance.
                    </div>
                  </div>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-if="tab == 1 && expandTab1"> </v-row>
      </div>
    </v-col>

    <v-col cols="12" v-if="tab == 2">
      <div class="d-flex justify-space-between align-center" v-if="!expandTab1">
        <div class="text-h6 font-weight-bold">Practicum Activities</div>
      </div>

      <div class="mt-4">
        <!-- Loading state -->
        <v-row v-if="tab == 2 && loading">
          <v-col cols="12" sm="6" md="4" v-for="n in 3" :key="'skeleton-' + n">
            <v-skeleton-loader type="card" class="rounded-lg" />
          </v-col>
        </v-row>

        <!-- Empty state -->
        <v-row
          v-else-if="tab == 2 && student_practicum_attendance.length === 0"
        >
          <v-col cols="12">
            <div class="text-center py-10">
              <v-icon size="44" color="grey-lighten-1"
                >mdi-calendar-blank-outline</v-icon
              >
              <div class="text-body-2 text-grey mt-2">
                No practicum activities scheduled yet.
              </div>
            </div>
          </v-col>
        </v-row>

        <!-- Cards -->
        <v-row v-else-if="tab == 2 && !expandTab1">
          <v-col
            cols="12"
            sm="6"
            md="4"
            v-for="i in student_practicum_attendance"
            :key="i.id"
          >
            <v-card
              flat
              rounded="lg"
              class="practicum-card pa-2"
              :style="{ borderColor: getTypeColor(i.type).text }"
            >
              <div class="d-flex justify-space-between pa-2 align-center">
                <div
                  class="text-uppercase font-weight-bold text-caption rounded-lg px-2 py-1"
                  :style="{
                    color: getTypeColor(i.type).text,
                    backgroundColor: getTypeColor(i.type).bg,
                  }"
                >
                  {{ i.type }}
                </div>

                <div
                  class="text-caption font-weight-bold px-2 py-1 rounded-lg"
                  :style="getAttendanceStatus(i).style"
                >
                  {{ getAttendanceStatus(i).label }}
                </div>
              </div>

              <div class="mt-2 px-2">
                <div class="text-subtitle-1 font-weight-bold">
                  {{ i.title }}
                </div>

                <div class="my-1 text-caption text-grey d-flex align-center">
                  <v-icon size="16">mdi-calendar</v-icon>
                  <span class="mx-2">{{ formatDate(i.date_sched) }}</span>
                </div>
                <div class="my-1 text-caption text-grey d-flex align-center">
                  <v-icon size="16">mdi-clock-outline</v-icon>
                  <span class="mx-2">
                    {{ formatTime(i.time_from) }} - {{ formatTime(i.time_to) }}
                  </span>
                </div>
                <div class="my-1 text-caption text-grey d-flex align-center">
                  <v-icon size="16">mdi-map-marker</v-icon>
                  <span class="mx-2">{{ i.venue || "—" }}</span>
                </div>
              </div>

              <div class="mt-2 px-2 pb-2">
                <v-divider class="mb-3" />
                <div v-for="ii in i.attendances" :key="ii.id">
                  <div class="text-caption text-grey">
                    {{ getTime(ii).detail }}
                  </div>
                  <div
                    class="text-caption font-weight-bold"
                    :style="{
                      color: i.attendance?.length ? '#00a63e' : '#9ca3af',
                    }"
                  >
                    {{ getTime(ii).time }}
                  </div>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </div>
      <!-- <div class="mt-4">
        <v-row v-if="tab == 2 && !expandTab1">
          <v-col cols="4" v-for="i in student_practicum_attendance" :key="i">
            <div class="rounded-lg pa-2" style="border: 1px solid #00a63e">
              <div class="d-flex justify-space-between pa-2 align-center">
                <div
                  style="color: #1447e6; background-color: #dbeafe"
                  class="text-uppercase font-weight-bold text-caption rounded-lg border border-1 px-1"
                >
                  {{ i.type }}
                </div>
                <div v-if="i.attendance.length > 0"
                  class="text-caption font-weight-bold border border-1 px-1 rounded-lg"
                  style="color: #00a63e; background-color: #f0fdf4"
                >
                  Attended
                </div>
              </div>
              <div class="mt-2">
                <div class="text-subtitle-1 font-weight-bold">
                  {{ i.title }}
                </div>
                <div class="my-1 text-caption text-grey d-flex align-center">
                  <v-icon>mdi-calendar</v-icon>
                  <span class="mx-2">{{ formatDate(i.date_sched) }}</span>
                </div>
                <div class="my-1 text-caption text-grey d-flex align-center">
                  <v-icon>mdi-clock-outline</v-icon>
                  <span class="mx-2"
                    >{{ formatTime(i.time_from) }} -
                    {{ formatTime(i.time_to) }}</span
                  >
                </div>
                <div class="my-1 text-caption text-grey d-flex align-center">
                  <v-icon>mdi-map-marker</v-icon>
                  <span class="mx-2">{{ i.venue }}</span>
                </div>
              </div>

              <div class="mt-2 py-4">
                <hr />
                <div class="mt-4 text-caption text-grey">Time In</div>
                <div class="text-caption font-weight-bold">09:05 AM</div>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row v-if="tab == 1 && expandTab1"> </v-row>
      </div> -->
    </v-col>

    <v-dialog v-model="dialogConfirmDelete" max-width="500">
      <v-card>
        <v-card-title class="text-h6">Confirm Deletion</v-card-title>
        <v-card-text class="text-body-1">
          Are you sure you want to delete this item?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="dialogConfirmDelete = false"
            >Cancel</v-btn
          >
          <v-btn color="error" class="white--text" @click="confirmDelete"
            >Confirm</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="scanAttendanceDialog"
      max-width="500"
      :persistent="isClosing"
      @update:model-value="onScanDialogChange"
    >
      <v-card>
        <v-card-title
          class="text-h6 text-center"
          style="background-color: #10b981 !important; color: #ffffff"
          ><div>Scan Attendance QR</div>
          <div class="text-caption">Align the QR code within the frame</div>
          <v-spacer></v-spacer>
          <v-btn
            icon="mdi-close"
            variant="text"
            color="white"
            :disabled="isClosing"
            @click="closeScanDialog"
          >
          </v-btn>
        </v-card-title>
        <v-card-text class="text-body-1">
          <qrcode-stream
            v-if="showScanner"
            :paused="isCaptured || isClosing"
            @detect="onDetect"
            @camera-off="onCameraOff"
          >
            <b
              v-if="isCaptured"
              style="
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
              "
              ><div class="text-white">Saving...</div>
              <div>
                <v-progress-linear
                  color="#10b981"
                  indeterminate
                ></v-progress-linear>
              </div>
            </b>
          </qrcode-stream>
          <div v-else class="text-center py-8 text-grey">Loading camera...</div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <ViewDTRGeneratorDialog :data="dtrItem" />
    <fade-away-message-component
      displayType="default"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :type="fadeAwayMessage.type"
    />
  </v-container>
</template>

<script>
import eventBus from "@/eventBus";
import { QrcodeStream } from "vue-qrcode-reader";
import ViewDTRGeneratorDialog from "../Dialogs/Views/ViewDTRGeneratorDialog.vue";

export default {
  components: {
    QrcodeStream,
    ViewDTRGeneratorDialog,
  },
  computed: {
    getProgressPercentage() {
      let prg = 0;
      if (this.t_ojt_hrs && this.ojt_hrs_to_complete) {
        prg = ((this.t_ojt_hrs / this.ojt_hrs_to_complete) * 100).toFixed(2);
      }
      return {
        prct: prg + "%",
        val: parseFloat(prg),
      };
    },
  },
  data: () => ({
    isCaptured: false,
    scanAttendanceDialog: false,
    isClosing: false,
    showScanner: false,
    scannerDelayId: null,
    closeTimeoutId: null,
    search: "",
    headers: [
      { title: "Organization", value: "organization_name", align: "start" },
      { title: "Date", value: "date", align: "start" },
      { title: "Time", value: "time", align: "start" },
      { title: "Type", value: "type", align: "start" },
    ],
    data: [],
    activeTab: { id: 1, name: "Duty Logs(DTR)" },
    tab: 1,
    tabList: [
      { id: 1, name: "Duty Logs(DTR)" },
      { id: 2, name: "Practicum" },
    ],
    programs_for: [],
    perPageChoices: [
      { text: "5", value: 5 },
      { text: "10", value: 10 },
      { text: "20", value: 20 },
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "250", value: 250 },
      { text: "500", value: 500 },
    ],
    expandTab1: false,
    expandTab2: false,
    expandTab3: false,
    table_data: [],
    t_ojt_hrs: null,
    ojt_hrs_to_complete: null,
    loading: false,
    options: {},
    action: null,
    paginationData: {},
    formdata: [],
    dialogConfirmDelete: false,
    dtrItem: null,
    fadeAwayMessage: {
      show: false,
      type: "success",
      header: "Successfully Deleted!",
      message: "",
      top: 10,
    },
    student_practicum_attendance: [],
  }),
  mounted() {
    this.loadAttendances();

    eventBus.on("closeViewDTRGenerateDialog", () => {
      this.loadAttendances();
    });
    // eventBus.on("closeSkillAssessmentBatchDialog", () => {
    //   this.initialize();
    // });
    // eventBus.on("closeAddProfilingFieldDialog", () => {
    //   this.loadAddedFields();
    // });
  },
  watch: {
    scanAttendanceDialog(val) {
      if (val) {
        this.isClosing = false;
        this.showScanner = false;
        if (this.scannerDelayId) clearTimeout(this.scannerDelayId);
        this.scannerDelayId = setTimeout(() => {
          this.showScanner = true;
          this.scannerDelayId = null;
        }, 300);
      } else {
        this.isCaptured = false;
        this.showScanner = false;
        if (this.scannerDelayId) {
          clearTimeout(this.scannerDelayId);
          this.scannerDelayId = null;
        }
      }
    },
  },
  beforeUnmount() {
    if (this.scannerDelayId) clearTimeout(this.scannerDelayId);
    if (this.closeTimeoutId) clearTimeout(this.closeTimeoutId);
    eventBus.off("closeViewDTRGenerateDialog");
    // eventBus.off("closeSkillAssessmentBatchDialog");
    // eventBus.off("closeAddProfilingFieldDialog");
  },
  methods: {
    formatType(type) {
      const labels = {
        am_in: "Morning Time In",
        am_out: "Morning Time Out",
        pm_in: "Afternoon Time In",
        pm_out: "Afternoon Time Out",
      };
      return labels[type] || type;
    },
    pagination(data) {
      this.paginationData = data;
    },

    showQRScanner() {
      this.isCaptured = false;
      this.scanAttendanceDialog = true;
    },

    closeScanDialog() {
      if (this.isClosing) return;
      this.isClosing = true;
      this.isCaptured = true;
      const doClose = () => {
        if (this.closeTimeoutId) {
          clearTimeout(this.closeTimeoutId);
          this.closeTimeoutId = null;
        }
        this.scanAttendanceDialog = false;
        this.isClosing = false;
        this.isCaptured = false;
      };
      this.closeTimeoutId = setTimeout(doClose, 400);
    },
    onScanDialogChange(val) {
      if (!val && !this.isClosing) {
        this.showScanner = false;
      }
    },
    onCameraOff() {
      if (this.isClosing && this.closeTimeoutId) {
        clearTimeout(this.closeTimeoutId);
        this.closeTimeoutId = null;
        this.scanAttendanceDialog = false;
        this.isClosing = false;
        this.isCaptured = false;
      }
    },

    async onDetect(detectedCodes) {
      if (this.isCaptured || !detectedCodes?.length) return;
      const rawValue = detectedCodes[0]?.rawValue;
      if (!rawValue) return;

      let payload;
      try {
        payload = JSON.parse(rawValue);
      } catch {
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "error";
        this.fadeAwayMessage.header = "Invalid QR Code";
        this.fadeAwayMessage.message =
          "Could not read QR code. Please scan a valid attendance QR.";
        this.isCaptured = false;
        return;
      }

      if (!payload.type) {
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "error";
        this.fadeAwayMessage.header = "Invalid QR Code";
        this.fadeAwayMessage.message = "QR code is missing required data.";
        this.isCaptured = false;
        return;
      }

      if (
        payload.org_id == null &&
        payload?.student_practicum_attendance_id == null
      ) {
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "error";
        this.fadeAwayMessage.header = "Invalid QR Code";
        this.fadeAwayMessage.message = "QR code is missing required data.";
        this.isCaptured = false;
        return;
      }

      this.isCaptured = true;

      try {
        const res = await this.axiosCall("/attendance/scan", "POST", {
          type: payload.type,
          org_id: payload.org_id,
          student_practicum_attendance_id:
            payload.student_practicum_attendance_id,
          date: payload.date || new Date().toISOString().split("T")[0],
        });
        if (res?.data?.status === 200 || res?.data?.status === 201) {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.header = "Attendance Recorded";
          this.fadeAwayMessage.message =
            res.data?.msg || "Your attendance has been recorded.";
          this.closeScanDialog();
          this.loadAttendances();
        } else {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "Error";
          this.fadeAwayMessage.message =
            res?.data?.message || "Failed to record attendance.";
          this.isCaptured = false;
        }
      } catch (err) {
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "error";
        this.fadeAwayMessage.header = "Error";
        this.fadeAwayMessage.message =
          err?.response?.data?.message ||
          "Failed to record attendance. Please try again.";
        this.isCaptured = false;
      }
    },

    loadAttendances() {
      this.loading = true;
      this.axiosCall("/attendance/my", "GET")
        .then((res) => {
          if (res?.data) {
            this.table_data = Array.isArray(res.data.attendance)
              ? res.data.attendance
              : res.data.attendance || [];
            this.t_ojt_hrs = res.data.completed_hrs;
            this.ojt_hrs_to_complete = res.data.total_ojt_hrs;
          }
          console.log(res.data);
        })
        .catch(() => {
          this.table_data = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },

    loadPracticumAttendances() {
      this.loading = true;
      this.axiosCall("/attendance/myPracticumAttendances", "GET")
        .then((res) => {
          if (res?.data) {
            this.student_practicum_attendance = Array.isArray(res.data)
              ? res.data
              : res.data || [];
          }
          console.log(res.data);
        })
        .catch(() => {
          this.table_data = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },

    changeTab(tab) {
      // this.activeTab = tab.abbr;
      // this.tab = tab.program_id;
      this.activeTab = tab.name;
      this.tab = tab.id;

      if (tab.id === 1) {
        this.loadAttendances();
      } else if (tab.id === 2) {
        this.loadPracticumAttendances();
      }

      this.expandTab1 = false;

      this.expandTab2 = false;

      this.expandTab3 = false;
    },

    editItem(item) {
      this.itemData = item;
      this.action = "Update";
    },

    viewItem(item) {
      this.itemData = item;
      this.action = "View";
    },

    genDtr() {
      this.dtrItem = { id: null };
    },

    manageItem(item) {
      this.creds = item;
    },

    getTypeColor(type) {
      const palette = {
        orientation: { text: "#1447e6", bg: "#dbeafe" },
        training: { text: "#7c3aed", bg: "#ede9fe" },
        seminar: { text: "#ea580c", bg: "#ffedd5" },
        meeting: { text: "#0d9488", bg: "#ccfbf1" },
        evaluation: { text: "#db2777", bg: "#fce7f3" },
        exit_interview: { text: "#dc2626", bg: "#fee2e2" },
      };
      const key = (type || "").toLowerCase().replace(/\s+/g, "_");
      return palette[key] || { text: "#4b5563", bg: "#f3f4f6" };
    },

    getAttendanceStatus(item) {
      const attended = item.attendance && item.attendance.length > 0;
      if (attended) {
        return {
          label: "Attended",
          style: { color: "#00a63e", backgroundColor: "#f0fdf4" },
        };
      }
      const eventDate = item.date_sched ? new Date(item.date_sched) : null;
      const isPast = eventDate && eventDate < new Date();
      return isPast
        ? {
            label: "Missed",
            style: { color: "#dc2626", backgroundColor: "#fee2e2" },
          }
        : {
            label: "Upcoming",
            style: { color: "#9ca3af", backgroundColor: "#f3f4f6" },
          };
    },

    getTimeIn(item) {
      if (!item.attendance || item.attendance.length === 0) return "—";
      // adjust `time_in` to match your actual attendance record field
      return item.attendance[0].time_in
        ? this.formatTime(item.attendance[0].time_in)
        : "—";
    },

    getTime(data) {
      console.log("getTime called with data:", data);
      if (data) {
        if (data.type === "am_in") {
          return {
            detail: "Morning Time In",
            time: data.time ? this.formatTime(data.time) : "—",
          };
        } else if (data.type === "am_out") {
          return {
            detail: "Morning Time Out",
            time: data.time ? this.formatTime(data.time) : "—",
          };
        } else if (data.type === "pm_in") {
          return {
            detail: "Afternoon Time In",
            time: data.time ? this.formatTime(data.time) : "—",
          };
        } else if (data.type === "pm_out") {
          return {
            detail: "Afternoon Time Out",
            time: data.time ? this.formatTime(data.time) : "—",
          };
        }
      }
      return "";
    },
  },
};
</script>

<style scoped>
.practicum-card {
  border: 1px solid #e5e7eb;
  transition: box-shadow 0.15s ease, transform 0.15s ease;
}
.practicum-card:hover {
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
  transform: translateY(-1px);
}
.hours-card {
  border: 1px solid #e5e7eb !important;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06) !important;
}
.table-card {
  border: 1px solid #d1d5db !important;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06) !important;
}
</style>
